import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const API = "/api";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);
  const [connectionError, setConnectionError] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me?token=${token}`, { timeout: 15000 });
          setUser(response.data);
          setConnectionError(null);
        } catch (error) {
          if (error.response?.status === 401 || error.response?.status === 403) {
            // Sadece yetki hatalarında çıkış yap
            localStorage.removeItem("token");
            setToken(null);
            setUser(null);
          } else if (error.code === 'ERR_NETWORK' || error.response?.status >= 500) {
            setConnectionError('Sunucuya bağlanılamıyor. Lütfen biraz bekleyip tekrar deneyin.');
          }
          // 502, 520 gibi hatalarda çıkış YAPMA - sadece bağlantı sorunu
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, [token]);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { 
        username, 
        password 
      }, { timeout: 10000 });
      const { access_token, user: userData } = response.data;
      localStorage.setItem("token", access_token);
      setToken(access_token);
      setUser(userData);
      setConnectionError(null);
      return userData;
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error') || error.message?.includes('SSL')) {
        throw new Error('Sunucuya bağlanılamıyor. SSL veya ağ hatası oluştu.');
      }
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, connectionError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
